import PropTypes from 'prop-types';

export const listTrackingPropType = PropTypes.shape({
    listID: PropTypes.string.isRequired,
    listType: PropTypes.string.isRequired,
});
